import {
  CaretDownOutlined,
  CloseOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
import { RouterString } from "Component/Modules/routesString";
import { LangCode } from "Component/Modules/Store/Code.recoil";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import "./Header.scss";

function Header() {
  const { t, i18n } = useTranslation();
  const [isMenuShow, setIsMenuShow] = useState(false);

  const [langCode, setLangCode] = useRecoilState(LangCode);
  const location = useLocation();

  // Sync i18n with Recoil state
  useEffect(() => {
    if (i18n.language !== langCode) {
      i18n.changeLanguage(langCode);
    }
  }, [langCode, i18n]);

  const onToggleMenu = () => {
    setIsMenuShow(!isMenuShow);
  };

  const handleSelectMenu = ({ item, key, keyPath, domEvent }: any) => {
    setLangCode(key);
    i18n.changeLanguage(key);
  };

  const langLabels: Record<string, string> = {
    jp: "JP",
    en: "ENG",
    kr: "KR",
  };

  const menu = (
    <Menu selectedKeys={[langCode]} onClick={handleSelectMenu}>
      <Menu.Item key={"jp"}>
        <span>JP</span>
      </Menu.Item>
      <Menu.Item key={"en"}>
        <span>ENG</span>
      </Menu.Item>
      <Menu.Item key={"kr"}>
        <span>KR</span>
      </Menu.Item>
    </Menu>
  );

  const handleClickMenu = () => {
    setIsMenuShow(false);
  };

  return (
    <>
      <section className="header" id="header">
        <div className="header-container">
          <nav className="nav">
            <Link className="logo" to="/">
              <h1>XUXU</h1>
            </Link>
            <div className={isMenuShow ? "bg" : ""} onClick={handleClickMenu}>
              <ul className={`${isMenuShow ? "nav-bar active" : "nav-bar"}`}>
                <li
                  className={`${location.pathname === "/about"
                    ? "nav-item active"
                    : "nav-item"
                    }`}
                >
                  <Link
                    to="/about"
                    onClick={handleClickMenu}
                    className="nav-link"
                  >
                    {t('menu.about')}
                  </Link>
                </li>
                <li
                  className={`${location.pathname === "/works"
                    ? "nav-item active"
                    : "nav-item"
                    }`}
                >
                  <Link
                    to={RouterString.WorkAll}
                    onClick={handleClickMenu}
                    className="nav-link"
                  >
                    {t('menu.works')}
                  </Link>
                </li>
                <li
                  className={`${location.pathname === "/contact"
                    ? "nav-item active"
                    : "nav-item"
                    }`}
                >
                  <Link
                    to="/contact"
                    onClick={handleClickMenu}
                    className="nav-link"
                  >
                    {t('menu.contact')}
                  </Link>
                </li>

                <div className="lang">
                  <span
                    onClick={() => {
                      setLangCode("jp");
                      i18n.changeLanguage("jp");
                      handleClickMenu();
                    }}
                    className={`${langCode === "jp" ? "active" : null}`}
                  >
                    JP
                  </span>
                  <span
                    onClick={() => {
                      setLangCode("en");
                      i18n.changeLanguage("en");
                      handleClickMenu();
                    }}
                    className={`${langCode === "en" ? "active" : null}`}
                  >
                    ENG
                  </span>
                  <span
                    onClick={() => {
                      setLangCode("kr");
                      i18n.changeLanguage("kr");
                      handleClickMenu();
                    }}
                    className={`${langCode === "kr" ? "active" : null}`}
                  >
                    KR
                  </span>
                </div>
              </ul>
            </div>

            <Dropdown className="languages" overlay={menu}>
              <span>
                {langLabels[langCode] ?? "JP"}{" "}
                <CaretDownOutlined className="languages-toggle-icon" />
              </span>
            </Dropdown>

            {isMenuShow ? (
              <span onClick={onToggleMenu} className="toggle-menu active">
                <CloseOutlined />
              </span>
            ) : (
              <span onClick={onToggleMenu} className="toggle-menu ">
                <MenuOutlined />
              </span>
            )}
          </nav>
        </div>
      </section>
    </>
  );
}

export default Header;
